import React, { Component, Fragment } from 'react';
import Sidebar from '../navigation/Sidebar';
import Rest from "../../services/Rest";
import { withRouter } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
const initialState = {
    camps: [],
    error: false,
    errorMessage: "",
    success: false,
    successMessage: "",
    busqueda: "",
    showSweet: false,
    id_eliminar: 0,
    showloader:false
}
class Listacamp extends Component {

    constructor(props) {
        super(props);
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
    }

    state = { ...initialState }

    //cuando la app carga
    componentDidMount() {
        this.obtenerCampañas();
    }

    obtenerCampañas = async () => {
        this.setState({
            showloader:true
        })
        this.Rest.get("campanas", this.datauser)
            .then(campañas => {
                if (campañas.status === 200) {
                    this.setState({
                        camps: campañas.data,
                        showloader:false
                    })
                }
                else {
                    if (campañas.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            errorMessage: campañas.message,
                            showloader:false
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    errorMessage: "Error de respuesta del servidor",
                    showloader:false
                })
            })
    }

    handleCheck = e => {
        e.persist();
        this.Rest.post(this.state.camps[e.target.dataset.id], 'campanas/estado', 'estatus', this.datauser)
            .then(resp => {
                if (resp.status === 200) {
                    this.setState({
                        error: false,
                        errorMessage: ""
                    }, () => {
                        let camps = [...this.state.camps]
                        camps[e.target.dataset.id]['habilitarCamp'] = resp.data.estatus
                        this.setState({
                            camps
                        })
                    })
                }
                else {
                    if (resp.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            errorMessage: resp.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    errorMessage: "Error de respuesta del servidor."
                })
            })
    }

    detalleCamp(id) {
        this.props.history.push("/detalle-campaña/" + id)
    }

    editarCamp(id) {
        this.props.history.push("/editar-campaña/" + id)
    }

    eliminarCamp() {
        let id = this.state.id_eliminar;
        const current = [...this.state.camps];
        this.Rest.delete("campanas/" + id, this.datauser)
            .then(response => {
                if (response.status === 200) {

                    let cam = current.filter(cc => cc.id_camp !== id);
                    this.setState({
                        camps: cam
                    })
                    this.setState({
                        success: true,
                        successMessage: "Campaña eliminada."
                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            errorMessage: response.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    errorMessage: "Error de respuesta del servidor."
                })
            })
        this.setState({
            showSweet: false
        })
    }

    showModal(id) {
        this.setState({
            showSweet: true,
            id_eliminar: id
        })
    }

    dismiss() {
        this.setState({
            error: false,
            errorMessage: "",
            success: false,
            successMessage: ""
        })
    }

    log = id_camp => {
        //ir a log de campaña
        this.props.history.push("/log-de-campaña/" + id_camp);
    }

    buscar(event) {
        this.setState({
            busqueda: event.target.value.substr(0, 20)
        })
    }

    limpiar() {
        this.setState({
            busqueda: ""
        })
    }

    actualizarLista(){
        this.obtenerCampañas()
    }

    render() {
        const { error, success, errorMessage, successMessage, showloader } = this.state;
        let camps = this.state.camps.filter(
            (camp) => {
                return camp.nombre.indexOf(this.state.busqueda) !== -1
            }
        )
        return (
            <Fragment>
                {showloader && 
                    <div className="uploader">
                    <div className="uploader-icon">
                        <p className="text-center">Actualizando la lista de campañas...</p>
                        <p className="text-center"><i className="fas fa-spinner fa-spin"></i></p>
                    </div>
                </div>
                }
                <div className="wrapper">
                    <Sidebar logout={() => this.props.callBackLogout()} />
                    <div id="content">

                        <div className="container">
                            {error ?
                                <div className="alert alert-danger alert-float">
                                    <button type="button" className="close" onClick={() => this.dismiss()}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    {errorMessage}
                                </div> : null}
                            {success ?
                                <div className="alert alert-success alert-float">
                                    <button type="button" className="close" onClick={() => this.dismiss()}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    {successMessage}
                                </div> : null}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="dashboard-panel">
                                        <h4 className="mb-center">Listado de campañas</h4>
                                        <div className="d-flex">
                                            <div>
                                                <ul className="list-inline">
                                                    <li className="list-inline-item">
                                                        Buscar una campaña:
                    </li>
                                                    <li className="list-inline-item">
                                                        <input type="search" name="buscarnumero" id="buscarnumero" className="form-control"
                                                            onChange={this.buscar.bind(this)}
                                                            value={this.state.busqueda} />
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <button className="btn btn-secondary" type="button"
                                                            onClick={() => this.limpiar()}>Limpiar</button>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <button className="btn btn-info" type="button"
                                                            onClick={() => this.actualizarLista()}>
                                                                {showloader ? "Actualizando la lista..." : "Actualizar lista"}
                                                            </button>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="ml-auto">
                                                <ul className="list-inline">
                                                    <li className="list-inline-item">
                                                        <div className="c">
                                                            <div className="c-header">Campañas</div>
                                                            <div className="c-body">
                                                                <span>
                                                                    {camps.length}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-condensed table-bordered">
                                                <thead>
                                                    <tr>

                                                        <th>Nombre de la campaña</th>
                                                        <th>Fecha y hora de inicio</th>
                                                        <th>Fecha y hora de finalización</th>
                                                        <th>Días de la semana</th>
                                                        <th>Habilitada</th>
                                                        <th>Estado de la campaña</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {camps !== null ?
                                                        camps.map((camp, index) => (
                                                            <tr key={index}>

                                                                <td>{camp.nombre}</td>
                                                                <td>{camp.fechaInicio} {camp.horaInicio}</td>
                                                                <td>{camp.fechaFinalizacion} {camp.horaFinalizacion}</td>
                                                                <td>
                                                                    <ul className="list-inline">
                                                                        {camp.dias ? camp.dias.map((dia, index) => (
                                                                            <li key={index} className="list-inline-item badge badge-secondary">{dia.dia}</li>
                                                                        )) : null}
                                                                    </ul>
                                                                </td>
                                                                <td align="center">


                                                                    <div className="custom-control custom-switch">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="custom-control-input"
                                                                            id={"habilitarCamp" + index}
                                                                            name={"habilitarCamp" + index}
                                                                            data-id={index}
                                                                            value={this.state.camps[index].habilitarCamp}
                                                                            onChange={this.handleCheck}
                                                                            defaultChecked={camp.habilitarCamp === "1" ? "checked" : ""} />
                                                                        <label className="custom-control-label" htmlFor={"habilitarCamp" + index}></label>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    {camp.estatus === "1" ?
                                                                        <button class="btn btn-block btn-warning disabled" disabled type="button">Procesando</button>
                                                                        :
                                                                        <button data-toggle="tooltip" data-placement="top" title={camp.estatusMensaje} className={"btn btn-block disabled " + camp.btnClass} disabled type="button">{camp.estatusMensaje}</button>}

                                                                </td>
                                                                <td>
                                                                    <div className="btn-group">
                                                                        <button type="button" className="btn btn-success"
                                                                            onClick={() => this.log(camp.id_camp)}
                                                                        >
                                                                            <i className="far fa-clock"></i>
                                                                        </button>
                                                                        <button type="button" className="btn btn-primary"
                                                                            onClick={() => this.detalleCamp(camp.id_camp)}>
                                                                            <i className="fas fa-list"></i>
                                                                        </button>
                                                                        <button type="button" className="btn btn-secondary" onClick={() => this.editarCamp(camp.id_camp)}>
                                                                            <i className="fas fa-pencil-alt"></i>
                                                                        </button>
                                                                        <button type="button" className="btn btn-danger"
                                                                            onClick={() => this.showModal(camp.id_camp)}
                                                                        >
                                                                            <i className="fas fa-times"></i>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                        :
                                                        <tr>
                                                            <td colSpan="6">
                                                                <div className="alert alert-warning">
                                                                    <strong>No campañas para mostrar</strong>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>


                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Sí"
                    confirmBtnBsStyle="danger"
                    cancelBtnText="Cancelar"
                    cancelBtnBsStyle="primary"
                    show={this.state.showSweet}
                    title="¿Realmente deseas eliminar esta campaña?"
                    text="¿Realmente deseas eliminar esta campaña?"
                    onCancel={() => this.setState({ showSweet: false })}
                    onConfirm={() => {
                        this.eliminarCamp(this.state.id_eliminar);
                    }}
                />


            </Fragment>
        );
    }
}

export default withRouter(Listacamp);


// WEBPACK FOOTER //
// ./src/components/campaigns/Listacamp.js